import { policies } from '../content/policies';
import { WebsiteDocument } from './website-document';
import '../assets/catalogue.css';
import '../assets/theme-content.css';

export function PolicyContent({ policy }: { policy: keyof typeof policies }) {
    return <div className="catalogue-content theme-content">
        <WebsiteDocument blocks={policies[policy].blocks} headingLevel="h2" />
        {policy === 'privacy' && <section>
            <h2>Further information</h2>
            <p className="line-height-3">You can find further information about relevant third-party services and UK data protection rights here:</p>
            <ul className="line-height-3">
                <li><a href="https://www.paddle.com/legal/privacy">Paddle Privacy Notice</a></li>
                <li><a href="https://auth0.com/docs/secure/data-privacy-and-compliance/data-processing">Auth0 Privacy Information</a></li>
                <li><a href="https://ico.org.uk/make-a-complaint/">Information Commissioner's Office</a></li>
            </ul>
        </section>}
    </div>;
}
